import { Grid } from "antd";

export type Layout = "mobile" | "tablet" | "desktop";

export function useLayoutBreakpoint(): Layout {
  const screens = Grid.useBreakpoint();
  if (screens.lg) return "desktop";
  if (screens.md) return "tablet";
  return "mobile";
}

export function useIsMobile(): boolean {
  return useLayoutBreakpoint() === "mobile";
}
